module.exports = __webpack_public_path__ + "static/potato-e6e42e1d5eee7ff1c70408a1f8a7bcb7.png";